import { RulesetSplitTest } from 'entities/rulesetSplitTest';
import { Client, Options } from 'services/apiGatewayClient';
import { createService } from 'services/genericAPIGatewayService';
import { State } from 'store';
import { ExpandedSite, RestEntity, rulesetSplitTests, mapWrappedResponseToEntity } from '../expandedQueries';
import { Service } from '../services';

export const clientOptions: Options<RulesetSplitTest, RulesetSplitTest, RestEntity<RulesetSplitTest>, ExpandedSite> = {
  mapToRequest: x => x,
  mapFromResponse: x => ({ id: x.id, entity: mapWrappedResponseToEntity(x) }),
  mapFromListResponse: rulesetSplitTests,
};

const client = new Client(clientOptions);

export const { Actions, Selectors, Sagas } = createService<RulesetSplitTest, Service.RulesetSplitTests>({
  service: Service.RulesetSplitTests,
  client,
  // eslint-disable-next-line
  endpointCreator: '/sites/${siteId}/campaigns/${campaignId}/rulesets/${rulesetId}/ruleset_split_tests',
  stateConverter: (state: State) => state.campaigns.rulesetSplitTests,
  redirectAfterCreateUrl: (siteId: string, _: string) => `/sites/${siteId}/campaigns/split_tests`,
  redirectAfterUpdateUrl: (siteId: string, _: string) => `/sites/${siteId}/campaigns/split_tests`,
  sagas: ['GET', 'GET_COLLECTION', 'CREATE', 'REDIRECT_AFTER_CREATE', 'DELETE', 'UPDATE', 'REDIRECT_AFTER_UPDATE'],
  watches: {
    getCollection: { parentUrlParam: 'siteId' },
  },
  endpointOverrides: {
    // eslint-disable-next-line
    getCollection: '/sites/${siteId}/ruleset_split_tests',
  },
  persistUpdates: true,
});
